import {createContext, useContext} from 'react'
import {LoadingState, PeriodType} from '../../../global'
import {Button} from '../global'
import {WpTypes} from '../wordpress-updates/types'

export interface Top5Interface {
    data: ItemTop5Interface[]
    title: string
}

export interface ItemTop5Interface {
    text: string
    sessions: string
}

export interface ReportAdministration {
    data: Data
    color: Color
    status: string
}

export interface Data {
    pub_meddle: PubMeddle
    position_header: PositionHeader
    position_top_5: PositionTop5
    partage_media_1: PartageMedia1
    partage_media_2: PartageMedia2
    position_6: Position6
    has_cleverPhone: boolean
    footer: ReportFooter
}

export interface PubMeddle {
    title: string
    sub_title: string
    text: string
    icon: any
    image: string
    button: Button
}

export interface PositionHeader {
    title: string
    sub_title: string
    text: string
    icon: any
    image: any
    button: any[]
}

export interface PositionTop5 {
    title: string
    sub_title: string
    text: string
    icon: any
    image: any
    button: any[]
}

export interface PartageMedia1 {
    title: string
    sub_title: string
    text: string
    icon: string
    image: any
    button: any
    status: boolean
}

export interface PartageMedia2 {
    title: string
    sub_title: string
    text: string
    icon: string
    image: any
    button: any
}

export interface Position6 {
    title: string
    sub_title: string
    text: string
    icon: any
    image: any
    button: Button
}

export interface Color {
    primary_color: string
    primary_color_50: string
    primary_color_25: string
    secondary_color: string
    secondary_color_50: string
    secondary_color_25: string
}

export interface ReportStatistics {
    totalVisites: number
    totalPagesvues: number
    totalConversions: number
    totalAppels: number
    totalClick: number
    totalForms: number
    totalContact: number
    totalUpdate: TotalUpdate
    cities: City[]
    visitedPages: VisitedPage[]
    channel: Channel[]
    tops: Top5Interface[]
}

export interface Wp {
    id: number
    update_id: number
    client_id: number
    date: string
    type: WpTypes
    name: string
    slug: string
    version_before: string
    version_after: string
    active: any
    data: any
    created_at: string
    updated_at: string
}

export interface TotalUpdate {
    total: Total
    wp: Wp[]
    theme: Wp[]
    plugin: Wp[]
}

export interface Total {
    wordPressBody: number
    modules: number
    themes: number
}

export interface City {
    city: string
    users: string
    sessions: string
}

export interface VisitedPage {
    users: string
    sessions: string
    path: string
    page: string
}

export interface Channel {
    keyword: string
    users: string
    sessions: string
}

export interface ReportFooter {
    title: string
    sub_title: string
    text: string
    data: any
    icon: any
    image: any
    button: any[]
}

const initialStatistics: ReportStatistics = {
    totalVisites: 0,
    totalPagesvues: 0,
    totalConversions: 0,
    totalAppels: 0,
    totalClick: 0,
    totalForms: 0,
    totalContact: 0,
    totalUpdate: {
        total: {
            wordPressBody: 0,
            modules: 0,
            themes: 0,
        },
        wp: [],
        theme: [],
        plugin: [],
    },
    cities: [],
    visitedPages: [],
    channel: [],
    tops: []
}

const initialAdministration: ReportAdministration = {
    data: {
        pub_meddle: {
            title: "",
            sub_title: "",
            text: "",
            icon: null,
            image: "",
            button: {
                title: "",
                href: "",
            },
        },
        position_header: {
            title: "",
            sub_title: "",
            text: "",
            icon: null,
            image: null,
            button: [],
        },
        position_top_5: {
            title: "",
            sub_title: "",
            text: "",
            icon: null,
            image: null,
            button: [],
        },
        partage_media_1: {
            title: "",
            sub_title: "",
            text: "",
            icon: "",
            image: null,
            button: null,
            status: false,
        },
        partage_media_2: {
            title: "",
            sub_title: "",
            text: "",
            icon: "",
            image: null,
            button: null,
        },
        position_6: {
            title: "",
            sub_title: "",
            text: "",
            icon: null,
            image: null,
            button: {
                title: "",
                href: "",
            },
        },
        has_cleverPhone: false,
        footer: {
            title: '',
            sub_title: '',
            text: '',
            data: '',
            icon: '',
            image: '',
            button: [],
        }
    },
    color: {
        primary_color: "",
        primary_color_50: "",
        primary_color_25: "",
        secondary_color: "",
        secondary_color_50: "",
        secondary_color_25: "",
    },
    status: "",
};

export interface ReportContextInterface {
    statistics: ReportStatistics
    administration: ReportAdministration
    loadingStatus: LoadingState
    period: PeriodType
}


export const initialReportState: ReportContextInterface = {
    statistics: initialStatistics,
    loadingStatus: 'idle',
    period: {start: '', end: ''},
    administration: initialAdministration,
}

export const ReportContext = createContext<ReportContextInterface>(initialReportState)

export const useReport = () => {
    const context = useContext(ReportContext)
    if (!context) throw new Error('useReport must be used within ReportProvider')
    return context
}